const vehicleInsuranceRouter = {
  path: '/vehicle-insurance',
  component: () => import('@/views/vehicle-insurance/index'),
  name: 'vehicle-insurance',
  meta: {
    title: '汽车玻璃保-玻璃无忧'
  }
}
export default vehicleInsuranceRouter
